/** Stable id shared with VaulDrawer titleId so the Grandfathering dialog is named by its visible heading. */
export const GRAND_FATHERING_HEADING_ID = 'grand-fathering-heading'
